export interface ResetPasswordFormValues {
  password: string;
  confirmPassword: string;
}

export enum ResetPasswordFields {
  password = "password",
  confirmPassword = "confirmPassword",
}
